module.exports = __webpack_public_path__ + "static/media/picto-candle.438dd3d6.svg";